import { PayloadAction } from '@reduxjs/toolkit';
import { put } from 'redux-saga/effects';

import * as API from 'services';

import { formatSettingMasterInfo } from './us1-01-unit-setting.helper';
import { UnitSettingActions } from './us1-01-unit-setting.redux';
import {
	TPayloadDeleteUnitSettingRequest,
	TPayloadGetUnitSettingListRequest,
	TPayloadUpdateUnitSettingRequest,
} from './us1-01-unit-setting.type';

export function* getUnitSettingMasterInfo(
	action: PayloadAction<TPayloadGetUnitSettingListRequest>
) {
	const { isWorker, callback } = action.payload;

	try {
		const res: API.ApiResponseSuccess<API.TGetSettingMasterInfoResponse> =
			yield API.getUnitSetting(isWorker);
		const unitSettingList = formatSettingMasterInfo(res?.data);
		yield put(
			UnitSettingActions.getUnitSettingSuccess({
				unitSettingList,
			})
		);
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(UnitSettingActions.getUnitSettingFailure());
	}
}

export function* updateUnitSettingMasterInfo(
	action: PayloadAction<TPayloadUpdateUnitSettingRequest>
) {
	const { callback, ...restPayload } = action.payload;
	try {
		yield API.updateUnitSetting(restPayload);
		yield put(UnitSettingActions.updateUnitSettingSuccess());
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(UnitSettingActions.updateUnitSettingFailure());
	}
}

export function* deleteUnitSettingMasterInfo(
	action: PayloadAction<TPayloadDeleteUnitSettingRequest>
) {
	const { callback, ...restPayload } = action.payload;
	try {
		yield API.deleteUnitSetting(restPayload);
		yield put(UnitSettingActions.deleteUnitSettingSuccess());
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(UnitSettingActions.deleteUnitSettingFailure());
	}
}
